import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'


function Fantasy() {

   const [movies, setMovies] = useState([])
  const navigate = useNavigate()
  const url =
    'https://api.themoviedb.org/3/list/14?api_key=ebec19ef414c8e83498a235dedd94d8b'
  useEffect(() => {
    axios.get(url).then((resp) => {
      setMovies(resp.data.items)
    })
  },[])
  // console.log(movies,'hfhfgfg');
  return (
     <div className="grid grid-cols-2 md:grid-cols-3 gap-5 lg:grid-cols-4 2xl:grid-cols-4">
      {movies.map((movie) => (
        <div key={movie.id}  onClick={() => navigate(`/movies/${movie.id}`) } className='cursor-pointer'>
          <img
            src={`https://image.tmdb.org/t/p/original/${movie.poster_path}`}
            alt=""
              className="w-[300px] h-[300px] md:w-[300px] md:h-[400px] object-cover hover:shadow-[0px_22px_70px_4px_rgba(0,0,0,0.35)] hover:transition duration-700 ease-in-out hover:skew-x-3 rounded-md "


            onClick={() => navigate(`/movies/${movie.id}`)}
          />
          <h3>{movie.title}</h3>
        </div>
      ))}
    </div>
  )
}

export default Fantasy
